var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":_vm.onForward}},[_c('AudioIcon'),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }